import React, { Component } from "react";
import Wrp from '../../../../hoc/Wrp/Wrp';
import Icons from "../../../../Components/Icons/Icons";
import TableData from "../../../../Components/UI/TableRecord/TableData/index"
import Pagination from "../../../../Components/UI/TableRecord/Pagination";

class DocumentListing extends Component {
	constructor(props) {
        super(props);
    }

    clickHandler = ()=>{

    }

    render () {

    	const tableHead = this.props.tableRecords.tableHead;
        const tableData = this.props.tableRecords.tableData;
        const pagination=this.props.tableRecords.pagination;
        let tableHeader = [];
        tableHead.map((header,index)=>{
            let styles;
            let innerHtml = null;
            let sortHtml = null;
            let stylesAttr = (header.styles!==undefined)?header.styles:{};
             if(header.type==='RadioButton' || header.type==='Checkbox'){
                styles={
                    width:'20px'
                }
            }
            styles = {
                ...styles,
                ...stylesAttr
            }
            
            let thEventHandler ={}
            if(header.clickHandler!==undefined){
                thEventHandler ={
                    onClick:header.clickHandler
                }
            }
            if(header.isShow && header.isShow===true){
                tableHeader.push(<th style={styles} key={index} {...thEventHandler}  {...header.attributes}> <span> {header.name} {innerHtml} </span> {sortHtml} </th>);
            }
            return header;
        });
        let ClassName = ['table','mb-0'];
    	return(
    		<Wrp>
    			<div className="table_Box dataTables_wrapper">
    				<div className="table_Body table-scroll-2 list_View p-0" style={{"overflow":"auto"}}>
    					<table className={ClassName.join(' ')}>
    						<thead className="table_tHeadBg">
	                            <tr key={'tableHeader'}>{tableHeader}</tr>
	                        </thead>
	                        <tbody>
	                        {
	                        	(tableData.status===200 && tableData.data.length>0)?
	                        	tableData.data.map((rows,rowIndex)=>{
	                        		let colInc = 0;
                                    let colIndex = 0;
                                    let rowsData = (rows.data)?rows.data:rows;
                                    let rowsEvent = {
                                        onClick:(rows.clickHandler)?rows.clickHandler:this.clickHandler(),
                                        className:(rows.className)?rows.className:"",
                                    }
                                    return (
                                    	<tr key={"row"+rowIndex} {...rowsEvent}>
                                    		{
	                                    		Object.entries(rowsData).map(([key, colData]) => {
	                                    			colInc++;
                                                 	colIndex = (colInc-1);
                                                 	if(colInc<=tableHead.length && tableHead[colIndex].isShow && tableHead[colIndex].isShow===true){
                                                 		let colDataAlter = colData;
                                                 		return(  
                                                            <TableData 
                                                            key={"col"+colIndex} 
                                                            id={"col"+colIndex} 
                                                            header={tableHead[colIndex]} 
                                                            colData={colDataAlter}
                                                            />
	                                                    )
                                                 	}
	                                    		})
                                    		}
                                    	</tr>
                                    );
	                        	})
	                        	: <tr><td className="text-center" colSpan={tableHead.length}>No Record exists</td></tr>
	                        }
	                        </tbody>
    					</table>
    				</div>
                                <div className="table_Footer">
                                    {(pagination.perPage) ?
                                        <Pagination
                                            {...pagination}
                                            recordsChangeHandler={this.props.callListingData}
                                        />
                                        : ''}
                                </div>
    			</div>
    		</Wrp>
    	)
    }
}

export default DocumentListing;
